import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Menu } from 'lucide-react';
import MenuSection from '../../components/POS/Menu/MenuSection';

/**
 * BrowsePOSScreen Component
 *
 * Read-only menu browsing mode
 * - No table selection required
 * - No cart/order functionality
 * - No table_split entry created
 * - Just for viewing menu items and checking availability
 */
export default function BrowsePOSScreen() {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Simple Header for Browse Mode */}
      <div className="bg-white border-b border-slate-200 shadow-sm">
        <div className="px-6 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-teal-700 flex items-center gap-2">
              <Menu size={28} />
              Browse Menu
            </h1>
            <p className="text-sm text-slate-500 mt-0.5">View available items (read-only mode)</p>
          </div>
          <button
            onClick={() => navigate('/pos/tables')}
            className="px-4 py-2 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition flex items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back to Tables
          </button>
        </div>
      </div>

      {/* Full Screen Menu */}
      <main className="flex-1 p-3 overflow-hidden">
        <div className="h-full bg-white rounded-lg shadow-lg border border-slate-200 overflow-hidden">
          <MenuSection browseMode={true} />
        </div>
      </main>
    </div>
  );
}
